export default {
  metadata: {
    version: '1.0.0',
    id: 'bottom-footer-1.0.0',
    name: 'JDSBottomFooter',
    platform: 'web'
  },
  hierarchy: {
    container: [
      {
        'copyright-container': [
          {
            'logo-container': [
              {
                'jds-icon-container': ['jds-icon']
              }
            ]
          },
          {
            'copyright-text-container': ['jds_link', 'jds-text']
          }
        ]
      },
      {
        'informational-links-container': ['jds_bottom_footer_link_item']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{b_0}',
      'justify-content': '{b_1}',
      'align-items': '{b_2}',
      'padding-top': '{b_3}',
      'padding-right': '{b_4}',
      'padding-bottom': '{b_5}',
      'padding-left': '{b_6}',
      background: '{b_7}'
    },
    jds_link: {
      textAppearance: 'body_xxs',
      kind: 'submenu',
      hidden: true
    },
    'copyright-container': {
      gap: '{b_8}',
      'flex-direction': '{b_9}',
      'align-items': '{b_10}',
      flex: 1
    },
    'informational-links-container': {
      'flex-direction': 'row',
      'align-items': '{b_11}',
      gap: 10
    },
    'jds-text': {
      'font-family': '{text_167}',
      color: '{text_21}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    },
    'jds-icon': {
      size: '{icon_24}',
      color: '{icon_12}'
    },
    'jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_23}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    }
  },
  variant: {
    _hasLink: {
      true: {
        jds_link: {
          hidden: false
        },
        'jds-text': {
          hidden: true
        }
      }
    },
    _platform: {
      desktop: {
        container: {
          width: '{b_12}'
        }
      },
      mobile: {
        container: {
          'flex-direction': '{b_13}',
          'justify-content': '{b_14}',
          'align-items': '{b_15}',
          'padding-top': 0,
          'padding-right': '{b_16}',
          'padding-bottom': '{b_17}',
          'padding-left': '{b_18}',
          gap: '{b_19}'
        },
        'copyright-container': {
          'flex-direction': '{b_20}',
          'align-items': '{b_21}',
          gap: '{b_22}'
        }
      }
    }
  },
  api: {
    config: {
      _hasLink: {
        values: [true, false]
      },
      _platform: {
        values: ['desktop', 'mobile']
      }
    },
    data: {
      'informational-links-container': {
        value: {
          name: 'informationalLinks',
          type: 'list',
          object: {
            title: 'string',
            href: 'string',
            separator: 'boolean'
          }
        }
      },
      'copyright-text-container': {
        value: {
          name: 'copyright',
          type: 'object',
          object: {
            title: 'string',
            href: 'string',
            newTab: 'boolean'
          }
        }
      },
      jds_link: {
        title: {
          type: 'string',
          name: 'copyright.title'
        },
        href: {
          type: 'string',
          name: 'copyright.href'
        },
        newTab: {
          type: 'boolean',
          name: 'copyright.newTab'
        }
      },
      jds_bottom_footer_link_item: {
        title: {
          type: 'string',
          name: 'informationalLinks.title'
        },
        href: {
          type: 'string',
          name: 'informationalLinks.href'
        },
        newTab: {
          type: 'boolean',
          name: 'informationalLinks.newTab',
          platform: 'web'
        },
        routerLinkProps: {
          type: 'string',
          name: 'informationalLinks.routerLinkProps',
          platform: 'angular'
        },
        provider: {
          type: 'string',
          name: 'informationalLinks.provider',
          platform: 'react'
        },
        onClick: {
          type: 'string',
          name: 'informationalLinks.onClick'
        },
        separator: {
          name: 'informationalLinks.separator',
          type: 'boolean'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'copyrightText'
        }
      },
      'jds-icon': {
        value: {
          type: 'icon',
          name: 'logo'
        }
      }
    },
    a11y: {
      jds_link: {
        properties: {
          ariaLabel: 'copyRightAriaLabel',
          ariaDescribedby: {
            name: 'copyRightAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'informational-links-container': {
        name: 'informationalLinks',
        repeating: {
          ariaLabel: 'bottomlinkAriaLabel',
          ariaDescribedby: {
            name: 'bottomlinkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_bottom_footer_link_item: {
        properties: {
          ariaLabel: 'informationalLinks.bottomlinkAriaLabel',
          ariaDescribedby: 'informationalLinks.bottomlinkAriaDescribedby'
        }
      }
    }
  }
};
